import React from 'react';
import PropTypes from 'prop-types';
import { getVolumeAndBrightnessOptions } from '../../../../utils/configHelpers';

const SlaveConfigSection = ({
  slaveHardwareConfig,
  onHardwareChange,
  sending,
}) => {
  return (
    <div>
      <h6 className="text-muted small text-uppercase mb-3 font-weight-bold config-preview-section-title">
        Configuración Esclava
      </h6>
      <ul className="list-unstyled mb-3 text-dark small">
        <li className="d-flex justify-content-between align-items-center py-1 config-preview-item-border">
          <span>Modo Debug:</span>
          <label className="custom-toggle-switch mb-0">
            <input
              type="checkbox"
              checked={!!slaveHardwareConfig.debug}
              onChange={(e) => onHardwareChange('slave', 'debug', e.target.checked)}
              disabled={sending}
            />
            <span className="toggle-slider"></span>
          </label>
        </li>
        <li className="d-flex justify-content-between align-items-center py-1 config-preview-item-border">
          <span>Sonido Global:</span>
          <label className="custom-toggle-switch mb-0">
            <input
              type="checkbox"
              checked={!!slaveHardwareConfig.buzzer_master_enabled}
              onChange={(e) => onHardwareChange('slave', 'buzzer_master_enabled', e.target.checked)}
              disabled={sending}
            />
            <span className="toggle-slider"></span>
          </label>
        </li>

        <li className="d-flex justify-content-between align-items-center py-1 config-preview-item-border opacity-75">
          <span className="text-muted">Habilitar Electroimán:</span>
          <label className="custom-toggle-switch mb-0">
            <input
              type="checkbox"
              checked={!!slaveHardwareConfig.relay_enabled}
              disabled={true}
            />
            <span className="toggle-slider"></span>
          </label>
        </li>
        <li className="d-flex justify-content-between align-items-center py-1 config-preview-item-border opacity-75">
          <span className="text-muted">Sensor Puerta:</span>
          <label className="custom-toggle-switch mb-0">
            <input
              type="checkbox"
              checked={!!slaveHardwareConfig.door_sensor_enabled}
              disabled={true}
            />
            <span className="toggle-slider"></span>
          </label>
        </li>
        <li className="d-flex justify-content-between align-items-center py-1 config-preview-item-border opacity-75">
          <span className="text-muted">Botón Emergencia:</span>
          <label className="custom-toggle-switch mb-0">
            <input
              type="checkbox"
              checked={!!slaveHardwareConfig.button_emergency_enabled}
              disabled={true}
            />
            <span className="toggle-slider"></span>
          </label>
        </li>

        <li className="d-flex justify-content-between align-items-center py-1 config-preview-item-border">
          <span>Luz RGB:</span>
          <label className="custom-toggle-switch mb-0">
            <input
              type="checkbox"
              checked={!!slaveHardwareConfig.rgb_enabled}
              onChange={(e) => onHardwareChange('slave', 'rgb_enabled', e.target.checked)}
              disabled={sending}
            />
            <span className="toggle-slider"></span>
          </label>
        </li>
        <li className="d-flex justify-content-between align-items-center py-1 config-preview-item-border">
          <span>Volumen Alarma:</span>
          <select
            value={slaveHardwareConfig.buzzer_alarm_volume !== undefined ? slaveHardwareConfig.buzzer_alarm_volume : 0}
            onChange={(e) => onHardwareChange('slave', 'buzzer_alarm_volume', parseInt(e.target.value) || 0)}
            disabled={sending}
            className="config-select"
          >
            {getVolumeAndBrightnessOptions(slaveHardwareConfig.buzzer_alarm_volume).map((val) => (
              <option key={val} value={val}>{val}</option>
            ))}
          </select>
        </li>
        <li className="d-flex justify-content-between align-items-center py-1 config-preview-item-border">
          <span>Brillo LED (RGB):</span>
          <select
            value={slaveHardwareConfig.led_brightness !== undefined ? slaveHardwareConfig.led_brightness : 0}
            onChange={(e) => onHardwareChange('slave', 'led_brightness', parseInt(e.target.value) || 0)}
            disabled={sending}
            className="config-select"
          >
            {getVolumeAndBrightnessOptions(slaveHardwareConfig.led_brightness).map((val) => (
              <option key={val} value={val}>{val}</option>
            ))}
          </select>
        </li>
      </ul>
    </div>
  );
};

SlaveConfigSection.propTypes = {
  slaveHardwareConfig: PropTypes.object.isRequired,
  onHardwareChange: PropTypes.func.isRequired,
  sending: PropTypes.bool.isRequired,
};

export default SlaveConfigSection;
